import React, { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { tradingResults } from "../lib/api";

const usd = (v) => `${v < 0 ? "-" : ""}$${Math.abs(v || 0).toFixed(2)}`;
const tone = (v) => (v > 0 ? "text-emerald-400" : v < 0 ? "text-rose-400" : "text-cyan-200/60");
const LABEL = { kalshi_desk: "Kalshi desk", oracle: "Oracle", no_desk: "NO desk", short_side: "Short-side", spot_futures: "Spot/futures", house_kalshi: "House Kalshi" };

export const ResultsCard = () => {
  const [r, setR] = useState(null);
  useEffect(() => { tradingResults(7).then(setR).catch(() => {}); }, []);
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="results-card">
      <p className="text-[#00F0FF] font-bold flex items-center gap-2"><TrendingUp className="w-4 h-4" /> Trading floor · last 7 days</p>
      {!r ? <p className="text-xs text-cyan-200/40">Loading…</p> : (
        <>
          <div className="grid grid-cols-3 gap-3">
            <div><p className="text-xs text-cyan-200/50">Realized P&L (after fees)</p><p className={`text-xl font-bold ${tone(r.realized_pnl_after_fees)}`} data-testid="results-pnl">{usd(r.realized_pnl_after_fees)}</p></div>
            <div><p className="text-xs text-cyan-200/50">Trades</p><p className="text-xl font-bold text-cyan-50" data-testid="results-trades">{r.trades}</p></div>
            <div><p className="text-xs text-cyan-200/50">Win rate</p><p className="text-xl font-bold text-cyan-50" data-testid="results-winrate">{r.win_rate}%</p></div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="results-desks">
            {Object.entries(r.desks).map(([k, d]) => (
              <div key={k} className="rounded-lg border border-[#00F0FF14] px-2 py-1.5 text-xs" data-testid={`results-desk-${k}`}>
                <p className="text-cyan-200/70">{LABEL[k] || k}</p>
                <p><span className={`font-bold ${tone(d.pnl)}`}>{usd(d.pnl)}</span> <span className="text-cyan-200/40">· {d.trades} tr · {d.win_rate}%</span></p>
              </div>))}
          </div>
          <p className="text-[10px] text-cyan-200/40">Fees paid: {usd(r.fees)}</p>
        </>
      )}
    </div>
  );
};
